declare var window:any

const Backbone = require('backbone')

const ClienteItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-listar-clientes-item",
    tagName: "tr",
    className: "",


    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
        $("input").on('focus', function () { $(this).select(); });
    },

    events: {
        'click td': "selecionar"

    },

    selecionar: function(e) {
        this.parent.clienteSelecionado(this.model);
    }
});

window.ClienteItemView = ClienteItemView


const ClienteView = Backbone.Marionette.CompositeView.extend({
    template: "#template-listar-clientes",
    childView: ClienteItemView,
    childViewContainer: "#lista-clientes-container",

    initialize: function(options) {
        this.app = options.app;
        this.clienteSelecionadoCallbackView = options.clienteSelecionadoCallbackView;
        this.clienteLimparCallback = options.clienteLimparCallback;
        $("input").on('focus', function () { $(this).select(); });

    },

    events: {
        'click #button-limpar-cliente-selecionado': "limparCliente"
    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this
        });
        return view;
    },

    clienteSelecionado: function(cliente) {


        if (!cliente || !this.clienteSelecionadoCallbackView) {
            return;
        }

        this.clienteSelecionadoCallbackView(cliente);
    },

    limparCliente: function() {

        if (!this.clienteLimparCallback) {
            return;
        }

        this.clienteLimparCallback();
    }

});

window.ClienteView = ClienteView

export {
    ClienteItemView, ClienteView
}